export function addDotsToNumber(value) {
  try {
    const numberString = typeof value === 'string' ? value : value.toString();
    const [integerPart, decimalPart] = numberString.split('.');
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return decimalPart ? `${formattedIntegerPart},${decimalPart}` : formattedIntegerPart;
  } catch (error) {
    return value;
  }
}
